module.exports = __webpack_public_path__ + "static/media/achievement-body-scan.7bd813ca.svg";